// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__1aSTr","link":"styles_link__ySTww"};